import type { FaireProductEntity } from "../../entity_types/product";

export const p_jpw5dpjzr5: FaireProductEntity = {
  token: "p_jpw5dpjzr5",
  type: "product",
  name: "Mulled Apple Cider | 9oz Fall Candle",
  brandToken: "b_uckpbd2jy4",
  brandName: "Modern Roots Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/54688ee4d5cf3a6d191d587b7272324db964d1fe151894f0fd56ada4494adf0b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87ebaeeb014958d19ff34a1b4ed9f87b34e7e511f97e21661d550646febc2cf3.png",
    "https://cdn.faire.com/fastly/64c6b3b4c126b4f38f70d282cd274f252c053d64455be2e96c3efff9489c60b8.png",
    "https://cdn.faire.com/fastly/28392dd87dc08457f00f46a7d34288ac011500847498398ba4d00f95b258b29e.png",
    "https://cdn.faire.com/fastly/b63c547212c8cf4b99faa04e2eb2581408ca6c9c6e2b38f4d13fec86d8ab2f6e.png",
    "https://cdn.faire.com/fastly/4ab66c59e59bfcdc8cf92feec8f97584823e8b2ecb834a3c845fbb5b72bdfd1b.png",
  ],
  priceDollars: 12.5,
  description:
    "Warm and inviting, this candle fills your space with the comforting aroma of mulled apple cider. Bright notes of orange peel, lemon, and cinnamon mingle with cranberry, red currant, and crisp apple cider, while rich notes of red wine and wood create a cozy, spiced finish.\n\nScent Notes: Orange Peel, Cinnamon, Lemon, Cranberry, Red Currant, Apple Cider, Red Wine, Wood\n-----------------------------------\nOur candles at Modern Roots Candle Co. are hand-poured in small batches and tested to precision. All candles are made with 100% natural soy wax, cotton braided wick, and clean fragrances infused with essential oils and free of phthalates. This combination makes for a cleaner and longer burn time.\n\nSingle wick candles are great for bedrooms and bathrooms.\n\nOur labels are printed on estate #9 paper for a premium textured feel.\n\n9 oz. Candle Burn Time: Up to 45 Hours",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:01.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
